import type { Subscriber } from "../types";
import { SubscriberList } from "./SubscriberList";

export const subscribers = {
  list: SubscriberList,
  recordRepresentation: (record: Subscriber) => record?.email ?? "Subscriber",
};

export default subscribers;
